/** @jsxImportSource theme-ui */

import React from 'react';

import AuthForm from './AuthForm';

export type AuthVariant =
  | 'signin'
  | 'resetPassword'
  | 'confirmResetPassword'
  | 'business_signup'
  | 'confirmSignup'
  | 'qr-code'
  | 'business_login';

interface AuthBoxProps {
  confirmCode?: string;
  initialEmail?: string;
  variant?: AuthVariant;
  referral?: string;
}

export default function AuthBox({
  confirmCode,
  initialEmail,
  variant = 'signin',
  referral = '',
}: AuthBoxProps) {
  const [currentVariant, setCurrentVariant] = React.useState(variant);

  React.useEffect(() => {
    setCurrentVariant(variant);
  }, [variant]);

  return (
    <AuthForm
      confirmCode={confirmCode}
      initialEmail={initialEmail}
      referral={referral}
      variant={currentVariant}
      setCurrentVariant={setCurrentVariant}
    />
  );
}
